import { FC, ReactNode } from 'react';
import Typography from '@ixigo/iui/Typography';

type ContentSectionProps = {
    title: string;
    children: ReactNode;
    className?: string;
    titleVariant?: 'body-sm' | 'body-md';
    titleWeight?: 'normal' | 'medium';
};

const ContentSection: FC<ContentSectionProps> = ({
    title,
    children,
    className = 'mb-20',
    titleVariant = 'body-sm',
    titleWeight = 'medium',
}) => (
    <div className={`${className} bg-neutral-60 rounded-[10px] p-[10px] border border-gray-200`}>
        <Typography
            variant={titleVariant}
            fontWeight={titleWeight}
            className='mb-10 bg-gradient-to-r from-yellow-800 via-orange-500 to-pink-700 bg-clip-text text-transparent inline-block'
        >
            {title}
        </Typography>
        {children}
    </div>
);

export default ContentSection;
